import loadable from '@loadable/component';

const LoginPage = loadable(async () => await import('src/pages/auth/login'));

const HomePage = loadable(async () => await import('src/pages/main/home'));
const SearchPage = loadable(async () => await import('src/pages/main/search'));
const UploadPage = loadable(async () => await import('src/pages/main/upload'));

const AppRoutes = {
	auth: [{ path: 'login', element: LoginPage }],
	main: [
		{ path: '', element: HomePage },
		{ path: 'search/:name', element: SearchPage },
		{ path: 'upload', element: UploadPage },
	],
};

export default AppRoutes;
